import type { RootState } from '@core/core/store'

import { cubesAdapter } from './cubeSlice'

export const { selectAll: selectAllCubes } = cubesAdapter.getSelectors<RootState>(
  state => state.cubes,
)
